import React, { useState, useEffect } from 'react';
import { Button } from '../components/Button';
import { SelectField } from '../components/Fields';
import { AuthLayout } from '../components/AuthLayout';
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import axios from 'axios';

function ActionSelection() {
	const [selectActionMessage, setSelectActionMessage] = useState('');
	const [action, setAction] = useState('');
	const location = useLocation();
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	
	// Determine which service type based on route
	const isSyntheticRoute = location.pathname.includes('/synthetic');
	const isContinuationRoute = location.pathname.includes('/continuation');
	
	// Load action from URL if present
	useEffect(() => {
		const urlAction = searchParams.get('action');
		if (urlAction) {
			setAction(urlAction);
		}
	}, [searchParams]);

	// Handle tokens from URL query parameters (in case accessed directly)
	useEffect(() => {
		const token = searchParams.get('token');
		const refreshToken = searchParams.get('refresh_token');
		
		if (token) {
			localStorage.setItem('access_token', token);
			axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
		}

		if (refreshToken) {
			localStorage.setItem('refresh_token', refreshToken);
		}

		// Clean up URL by removing token params
		if (token || refreshToken) {
			const newSearchParams = new URLSearchParams(window.location.search);
			newSearchParams.delete('token');
			newSearchParams.delete('refresh_token');
			const newSearch = newSearchParams.toString();
			const newUrl = window.location.pathname + (newSearch ? `?${newSearch}` : '');
			window.history.replaceState({}, '', newUrl);
		}
	}, [searchParams]);

	const handleSubmit = (e) => {
		e.preventDefault();
		const isSupport = window.location.search === '?support' || window.location.search.includes('support');
		
		if (!action || action === '') {
			setSelectActionMessage('Action type is required');
			return;
		}
		
		// Pass action via URL parameters
		if (action === 'cont') {
			if (isSupport) {
				navigate(`/selfservice/continuation/check-number?action=${action}&support`);
			} else {
				navigate(`/selfservice/continuation/check-number?action=${action}`);
			}
		} else if (action === 'add_aso' || action === 'add_sca') {
			if (isSupport) {
				navigate(`/selfservice/continuation/verify-code?action=${action}&support`);
			} else {
				navigate(`/selfservice/continuation/verify-code?action=${action}`);
			}
		} else if (action === 'add_ss' || action === 'add_ss_lite' || action === 'ssi' || action === 'add_aso_ss') {
			navigate(`/selfservice/synthetic/new-account?action=${action}`);
		} else {
			setSelectActionMessage('Action type is required');
		}
	};

	return (
		<AuthLayout>
			<form onSubmit={handleSubmit}>
				<div className="grid grid-cols-1 gap-6">
					<h1 className="text-center font-medium text-[1.3rem] mb-4">
						{isSyntheticRoute ? 'Self Service - Synthetic Signals' : isContinuationRoute ? 'Continuation Services' : 'Select Action Type'}
					</h1>
					<SelectField
						className="col-span-full"
						label="Action Type"
						id="action_type"
						name="action_type"
						value={action}
						onChange={e => {
							const selectedAction = e.target.value;
							setAction(selectedAction);
						}}
					>
						<option value="" disabled>Select an action</option>
						{isSyntheticRoute ? (
							<>
								<option value="add_ss">Add Synthetic Signal</option>
								<option value="add_ss_lite">Add Synthetic Signal Lite</option>
								<option value="ssi">Add Synthetic Signals Instant</option>
								<option value="add_aso_ss">Add Aso for Synthetic Signal</option>
							</>
						) : isContinuationRoute ? (
							<>
								<option value="cont">Account continuation</option>
								<option value="add_sca">Add Second Chance Account</option>
								<option value="add_aso">Add Aso</option>
							</>
						) : (
							<>
								<option value="add_sca">Add Second Chance Account</option>
								<option value="add_aso">Add Aso</option>
								<option value="add_aso_ss">Add Aso for Synthetic Signal</option>
								<option value="cont">Account continuation</option>
								<option value="add_ss">Add Synthetic Signal</option>
								<option value="add_ss_lite">Add Synthetic Signal Lite</option>
								<option value="ssi">Add Synthetic Signals Instant</option>
							</>
						)}
					</SelectField>
				</div>
				<p className="text-center">{selectActionMessage}</p>
				<Button type="submit" color="cyan" className="mt-8 mb-5 w-full duration-200 hover:bg-gray-800 focus:bg-[#28a745] focus:text-white/80">
					Continue
				</Button>
				{/* Show guide links based on route */}
				{isSyntheticRoute && (
					<a className="underline" href="https://drive.google.com/file/d/1uRUyVimJUnwof9VSWxzJA1MbuAZh-zbd/view?usp=sharing" target="_blank" rel="noreferrer">
						<p className="text-center">Synthetic signal guide</p>
					</a>
				)}
				{isContinuationRoute && (
					<a className="underline" href="https://ft9ja.notion.site/How-to-Connect-Your-Account-to-Your-Dashboard-Using-FT9ja-Self-Service-FXTM-Accounts-1bbaa5a0912e80c7bd1dd880c037e0c5 " target="_blank" rel="noreferrer">
						<p className="text-center">Continuation guide</p>
					</a>
				)}
			</form>
		</AuthLayout>
	);
}

export default ActionSelection;

